// ** Logo
import logo from '@src/assets/images/logo/Logo Main.png'

const SpinnerComponent = () => {
  return (
    <div style={{background: "white"}} className='fallback-spinner app-loader'>
      <img style={{height: 70}} className='fallback-logo' src={logo} alt='logo' />
      <div style={{marginLeft: 80}} className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default SpinnerComponent
